import { useEffect, useState } from 'react';

import { formDataInstance } from '@/common/axios';
import CONFIG from '@/config';
import {
  NoteCategory,
  NoteFollowupTimes,
  NoteSalesRep,
  NoteStaff
} from '@/views/Pages/Customer/CustomerProfile/CustomerTabs/NewAlertsNotes/Types';

export interface CustomerNoteEnumData {
  contactedVia: string[];
  followupTimes: NoteFollowupTimes[];
  noteActorTypes: string[];
  noteCategories: NoteCategory[];
  noteTypes: string[];
  staff: NoteStaff[];
  salesRep: NoteSalesRep[];
  status: string[];
}

export interface CustomerNoteEnumInfo {
  enums: CustomerNoteEnumData;
  loading: boolean;
}

export interface CustomerNoteEnumsApiResponse {
  data: {
    data: CustomerNoteEnumData;
  };
}

export const apiSuffix = '/staff/notes-config';

// state needed for these across hook instances
let cachedEnums: CustomerNoteEnumData = null;
let requestMade = false;

export const useCustomerNoteEnums = (): CustomerNoteEnumInfo => {
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (cachedEnums || requestMade) {
      return;
    }
    setLoading(true);
    requestMade = true;
    formDataInstance
      .get(`${CONFIG.USERS_API_URL}${apiSuffix}`)
      .then(
        (response: CustomerNoteEnumsApiResponse) =>
          (cachedEnums = response.data.data)
      )
      .catch(error => console.error(error))
      .finally(() => setLoading(false));
  }, []);

  return {
    enums: cachedEnums,
    loading
  };
};
